<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import { dateFormat } from "@/core/services/helpers"
  import { ptBR } from "vuejs-datepicker/dist/locale"
  import SectionPointForm from "@/domains/lines/views/sectionPoints/partials/SectionPointForm.vue"

  export default {
    components: {
      Breadcrumbs,
      SectionPointForm,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
    },
    data: () => {
      return {
        locale: ptBR,
        dateFormat,
        title: "Atualizar Ponto Seção",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          {
            name: "Pontos de Seção",
            path: "lines.sectionpoints",
          },
          {
            name: "Atualizar Ponto de Seção",
            path: "lines.sectionpoints.edit",
          },
        ],
        sectionPoint: {
          idpontosecao: "",
          nmlocalidade: "",
          delocalidade: "",
          numunicipio: "",
          gelat: "",
          gelng: "",
          city: "",
          flsituacao: "",
        },
      }
    },
    async mounted() {
      this.$axios
        .get(`/api/lines/section-point/${this.id}`)
        .then((response) => {
          this.sectionPoint = { ...response.data }
        })
        .catch((error) => {
          this.$toast.error({
            title: "Erro",
            message: error.response.data.error,
          })
        })
    },
    methods: {
      submit() {
        this.$axios
          .put(
            "/api/lines/section-point/" + this.sectionPoint.idpontosecao,
            this.sectionPoint
          )
          .then(() => {
            this.$toast.success({
              title: "OK",
              message: "Ponto de seção atualizado com sucesso",
            })
            this.$router.push({ name: "lines.sectionpoints" })
          })
          .catch((error) => {
            this.$toast.error({
              title: "Erro",
              message: error.response.data.error,
            })
          })
      },
    },
  }
</script>
<style>
  .date-picker-seasonality > .vdp-datepicker__calendar {
    width: 100% !important;
  }
</style>

<template>
  <div class="w-full bg-gray-light">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
      >
        <h1 class="text-green-base uppercase pt-5">Atualizar Ponto de Seção</h1>
      </div>
      <SectionPointForm :sectionPoint="sectionPoint" @submit="submit"/>
    </div>
  </div>
</template>
